<template>
  <div class="companies">
    <SectionHeader :companySelect="false">
      <template v-slot:breadcrumbs>
        <h1>
          <router-link to="/admin/users">{{ $t('companies.admin') }}</router-link>
          <router-link to="/admin/companies">{{ $t('meta.companies') }}</router-link>
          {{ $t('companies.addCompany') }}
        </h1>
      </template>
      <template v-slot:meta>
        <router-link to="/admin/companies" class="button button-grey button-round button-small">{{
          $t('companies.allCompanies')
        }}</router-link>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <div class="entries-wrap">
        <AdminNav />

        <div class="body">
          <div class="content-wrap">
            <header class="content-header cf">
              <h3>{{ $t('containers.baseData') }}</h3>
            </header>
            <div class="content-body">
              <Form @submit="submit" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/views/admin/companies/Form.vue'

import SectionHeader from '@/components/SectionHeader'
import AdminNav from '@/components/admin_nav'

import adminsApi from '@/api/admin'

export default {
  components: {
    AdminNav,
    Form,
    SectionHeader,
  },
  data: () => ({
    company: {},
  }),
  methods: {
    async submit(company) {
      const success = await adminsApi.companies.create(company)
      if (success) {
        await this.$router.push({ name: 'admin_companies' })
      }
    },
  },
}
</script>
